// extracted by mini-css-extract-plugin
module.exports = {"terms":"Terms_terms__1hlaQ"};